module.exports = __webpack_public_path__ + "assets/img/AuditCover-w960.1ed2be4b.jpg";